// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ceb039b2","455":"7612885c","977":"e051b51f"}[chunkId] + ".chunk.js";
};